export const translations = {
  NL: {
    common: {
      cancel: 'Annuleren',
      add: 'Voeg toe',
      rteAriaLabel: 'Inhoud van Rich text editor',
      rteTitle: 'Inhoud van Rich text editor',
    },
    errortext: {
      urlNotValid: 'Geen geldige url',
      linkTextNotValid: 'Geen geldige link tekst',
    },
    format: {
      boldTooltip: 'Vet (Ctrl + B)',
      italicTooltip: 'Cursief (Ctrl + I)',
      numberTooltip: 'Genummerde lijst (Ctrl + Shift + 7)',
      bulletTooltip: 'Ongenummerde lijst (Ctrl + Shift + 8)',
      undoTooltip: 'Ongedaan maken (Ctrl + Z)',
      redoTooltip: 'Opnieuw uitvoeren (Ctrl + Y)',
    },
    aria: {
      labels: {
        bold: 'Maak de selectie vet',
        italic: 'Maak de selectie cursief',
        number: 'Maak van de selectie een genummerde lijst',
        bullet: 'Maak van de selectie een lijst',
        undo: 'Ongedaan maken',
        redo: 'Opnieuw uitvoeren',
        link: 'Maak van de selectie een link',
        table: 'Voeg een tabel in op de cursor positie',
        linkField: 'Voer een url in',
        linkTextfield: 'Voer een link tekst in',
        linkOkButton: 'Pas link en link tekst toe',
        linkEditButton: 'Bewerk de link (Ctrl + Shift + L)',
        linkTestButton: 'Test de link (Ctrl + Shift + 1)',
        linkDeleteButton: 'Verwijder de link (Ctrl + Shift + Q)',
        tableRowfield: 'Voer het aantal rijen in',
        tableColumnfield: 'Voer het aantal kolommen in',
        tableOkButton: 'Voeg tabel toe',
        tableInsertRowAbove: 'Voeg rij in boven',
        tableInsertRowBelow: 'Voeg rij in onder',
        tableDeleteRow: 'Verwijder rij',
        tableInsertColumnLeft: 'Voeg kolom links in',
        tableInsertColumnRight: 'Voeg kolom rechts in',
        tableDeleteColumn: 'Verwijder kolom',
        tableDeleteTable: 'Verwijder tabel',
        cancelButton: 'Annuleren',
        courselink: 'Voeg link naar vak toe',
        programmelink: 'Voeg link naar opleiding toe',
        searchField: 'Voer zoekterm in',
      },
      keyshortcuts: {
        bold: 'Control+B',
        italic: 'Control+I',
        number: 'Control+Shift+7',
        bullet: 'Control+Shift+8',
        undo: 'Control+Z',
        redo: 'Control+Y',
        link: 'Control+Shift+L',
        editlink: 'Control+Shift+L',
        deletelink: 'Control+Shift+Q',
        testlink: 'Control+Shift+T',
        table: 'Control+Shift+9',
        courselink: 'Control+Shift+Alt+C',
        programmelink: 'Control+Shift+Alt+P',
      },
    },
    table: {
      nrofRows: 'Aantal rijen',
      nrofRowsPlaceholder: 'aantal rijen',
      nrofColumns: 'Aantal kolommen',
      nrofColumnsPlaceholder: 'aantal kolommen',
      insertRowAbove: 'Voeg rij boven toe',
      insertRowBelow: 'Voeg rij onder toe',
      deleteRow: 'Verwijder rij',
      insertColumnLeft: 'Voeg kolom links toe',
      insertColumnRight: 'Voeg kolom rechts toe',
      deleteColumn: 'Verwijder kolom',
      deleteTable: 'Verwijder tabel',
      tableTooltip: 'Voeg tabel toe (Ctrl + Shift + 9)',
    },
    links: {
      linkLabel: 'Externe link',
      addLink: 'Pas toe',
      linkText: 'Link tekst',
      linkPlaceholder: 'www.voorbeeld.nl',
      linkTooltip: 'Voeg link toe (Ctrl + Shift + U)',
      linkEdittip: 'Bewerk link (Ctrl + Shift + L)',
      linkTesttip: 'Test link (Ctrl + Shift + 1)',
      linkDeletetip: 'Verwijder link (Ctrl + Shift + Q)',
    },
    cataloguelinks: {
      courseButtonLabel: 'Link naar vak',
      courseTooltip: 'Link naar vak toevoegen (Ctrl + Shift + Alt + C)',
      programmeTooltip: 'Link naar opleiding toevoegen (Ctrl + Shift + Alt + P)',
      programmeButtonLabel: 'Link naar opleiding',
      searchCourseFieldLabel: 'Zoek op naam of studiegidsnummer. Voer ten minste 4 karakters in.',
      searchProgrammeFieldLabel: 'Zoek op naam of opleidingscode. Voer ten minste 4 karakters in.',
      searchFieldPlaceholder: 'Voer zoekterm in',
      resultCourseListCatalogNumber: 'Studiegidsnummer',
      resultProgrammeListCatalogNumber: 'Opleidingscode',
      resultListName: 'Naam',
      loading: 'Bezig met laden...',
      noResults: 'Geen resultaten gevonden',
    },
  },
  EN: {
    common: {
      cancel: 'Cancel',
      add: 'Add',
      rteAriaLabel: 'Rich text editor content',
      rteTitle: 'Rich text editor content',
    },
    errortext: {
      urlNotValid: 'No valid url',
      linkTextNotValid: 'No valid link text',
    },
    format: {
      boldTooltip: 'Bold (Ctrl + B)',
      italicTooltip: 'Italic (Ctrl + I)',
      numberTooltip: 'Ordered list (Ctrl + Shift + O)',
      bulletTooltip: 'Unordered list (Ctrl + Shift + U)',
      undoTooltip: 'Undo (Ctrl + Z)',
      redoTooltip: 'Redo (Ctrl + Y)',
    },
    aria: {
      labels: {
        bold: 'Make the selection bold',
        italic: 'Make the selection italic',
        number: 'Make the selection an ordered list',
        bullet: 'Make the selection an unordered list',
        undo: 'Undo',
        redo: 'Redo',
        link: 'Turn the selection into a link',
        table: 'Insert a table at the cursor position',
        linkField: 'Enter a url',
        linkTextfield: 'Enter a link text',
        linkOkButton: 'Apply link and link text',
        linkEditButton: 'Edit the link (Ctrl + Shift + L)',
        linkTestButton: 'Test the link (Ctrl + Shift + 1)',
        linkDeleteButton: 'Delete the link (Ctrl + Shift + Q)',
        tableRowfield: 'Enter the number of rows',
        tableColumnfield: 'Enter the number of columns',
        tableOkButton: 'Add table',
        tableInsertRowAbove: 'Insert row above',
        tableInsertRowBelow: 'Insert row below',
        tableDeleteRow: 'Delete row',
        tableInsertColumnLeft: 'Insert column left',
        tableInsertColumnRight: 'Insert column right',
        tableDeleteColumn: 'Delete column',
        tableDeleteTable: 'Delete table',
        cancelButton: 'Cancel',
        courselink: 'Add link to course',
        programmelink: 'Add link to programme',
        searchField: 'Enter search term',
      },
      keyshortcuts: {
        bold: 'Control+B',
        italic: 'Control+I',
        number: 'Control+Shift+7',
        bullet: 'Control+Shift+8',
        undo: 'Control+Z',
        redo: 'Control+Y',
        link: 'Control+Shift+U',
        editlink: 'Control+Shift+L',
        deletelink: 'Control+Shift+Q',
        testlink: 'Control+Shift+1',
        table: 'Control+Shift+9',
        courselink: 'Control+Shift+Alt+C',
        programmelink: 'Control+Shift+Alt+P',
      },
    },
    table: {
      nrofRows: 'Number of rows',
      nrofRowsPlaceholder: 'number of rows',
      nrofColumns: 'Number of columns',
      nrofColumnsPlaceholder: 'number of columns',
      insertRowAbove: 'Insert row above',
      insertRowBelow: 'Insert row below',
      deleteRow: 'Delete row',
      insertColumnLeft: 'Insert column left',
      insertColumnRight: 'Insert column right',
      deleteColumn: 'Delete column',
      deleteTable: 'Delete table',
      tableTooltip: 'Add table (Ctrl + Shift + 9)',
    },
    links: {
      linkLabel: 'External link',
      addLink: 'Apply',
      linkText: 'Link text',
      linkPlaceholder: 'www.example.com',
      linkTooltip: 'Add link (Ctrl + Shift + U)',
      linkEdittip: 'Edit link (Ctrl + Shift + L)',
      linkTesttip: 'Test link (Ctrl + Shift + 1)',
      linkDeletetip: 'Delete link (Ctrl + Shift + Q)',
    },
    cataloguelinks: {
      courseButtonLabel: 'Link to course',
      courseTooltip: 'Add link to course (Ctrl + Shift + Alt + C)',
      programmeTooltip: 'Add link to programme (Ctrl + Shift + Alt + P)',
      programmeButtonLabel: 'Link to programme',
      searchCourseFieldLabel: 'Search by name or catalogue number. Enter at least 4 characters.',
      searchProgrammeFieldLabel: 'Search by name or programme code. Enter at least 4 characters.',
      searchFieldPlaceholder: 'Enter search term',
      resultCourseListCatalogNumber: 'Catalogue number',
      resultProgrammeListCatalogNumber: 'Programme code',
      resultListName: 'Name',
      loading: 'Loading...',
      noResults: 'No results found',
    },
  },
};
